export default __webpack_public_path__ + "static/media/post_office.d1dc8b60.svg";